import { ProgramStatus } from 'src/features/programsV2/types/program';

import { Program } from '../../../types/program';

export const formatPublishStepValues = (program: Program) => {
  let publish = '';
  let date = null;
  let time = null;

  if (program.releaseDate) {
    publish = ProgramStatus.Scheduled;
    const releaseDate = new Date(program.releaseDate);

    date = releaseDate;
    time = releaseDate;
  }

  return {
    publish,
    date,
    time,
  };
};
